import React from 'react';
import { agentPlatformMenuIconPaths } from '../../constants/agentPlatformMenuIcons';
import { AgentPlatformHubRobotIcon } from './AgentPlatformHubRobotIcon';

type IconKey = keyof typeof agentPlatformMenuIconPaths | 'agents';

type Props = {
  icon: IconKey;
  className?: string;
};

export const AgentPlatformMenuIcon: React.FC<Props> = ({
  icon,
  className = 'h-5 w-5',
}) => {
  if (icon === 'agents') {
    return <AgentPlatformHubRobotIcon className={className} />;
  }

  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.75}
      aria-hidden
    >
      <path strokeLinecap="round" strokeLinejoin="round" d={agentPlatformMenuIconPaths[icon]} />
    </svg>
  );
};
